/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-15 15:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Card, Heading, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import TickIcon from 'src/assets/images/subscription-v4/tick.svg';
import EnterPriseBg from 'src/assets/images/subscription-v4/enterprise-banner.png';

type Props = {
  active: boolean,
  handleChangeModal: Function
};

type ComposedProps = Props & WithI18nProps;

class EnterpriseBlock extends Component<ComposedProps> {
  state = {
    isScrollToBottom: false
  };

  render() {
    const { i18n, onTalkToSale } = this.props;

    return (
      <div className="EnterpriseBlock">
        <Card>
          <div className="left">
            <Heading>{i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.title`)}</Heading>
            <div className="label">
              {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.label`)}
            </div>
            <div className="list-feature">
              <div>
                <img src={TickIcon} alt="stars" width={10} height={10} />
                <span>
                  {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.feature_unlimit`)}
                </span>
              </div>
              <div>
                <img src={TickIcon} alt="stars" width={10} height={10} />
                <span>
                  {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.feature_support`)}
                </span>
              </div>
              <div>
                <img src={TickIcon} alt="stars" width={10} height={10} />
                <span>
                  {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.feature_infra`)}
                </span>
              </div>
              <div>
                <img src={TickIcon} alt="stars" width={10} height={10} />
                <span>
                  {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.feature_b2b`)}
                </span>
              </div>
              <div>
                <img src={TickIcon} alt="stars" width={10} height={10} />
                <span>
                  {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.feature_custom`)}
                </span>
              </div>
              <div>
                <img src={TickIcon} alt="stars" width={10} height={10} />
                <span>
                  {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.feature_cs`)}
                </span>
              </div>
              <div>
                <img src={TickIcon} alt="stars" width={10} height={10} />
                <span>
                  {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.feature_sale`)}
                </span>
              </div>
            </div>
            <div>
              <Button primary onClick={onTalkToSale}>
                {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Enterprise.btn`)}
              </Button>
            </div>
          </div>
          <div className="right">
            <img src={EnterPriseBg} alt="bg" />
          </div>
        </Card>
      </div>
    );
  }

  handleChange = () => {
    this.props.handleChangeModal();
  };

  handleScroll = () => {
    this.setState({ isScrollToBottom: true });
  };

  handleSubscribe = () => {
    this.props.handleChangeModal();
    this.props.subscribe();
  };
}

export default withI18n()(EnterpriseBlock);
